<template>
  <v-layout id="overflow-container" style="width: 100%; height: 95%">
    <table style="width: 100%" class="candidate-table">
      <thead>
        <tr id="activeTable-header-row">
          <th style="width: 30%">Driver</th>
          <th style="width: 20%">Group</th>
          <th style="width: 5%">ETA</th>
          <th style="width: 3%">#FOJ</th>
          <th style="width: 5%">Dropoff&nbsp;ETA</th>
          <th style="width: 57%">Destination</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="candidate-row"
          v-for="driver in candidateDrivers"
          @click="selectDriver(driver.id)"
          v-bind:style="styleForRow(driver)"
        >
          <td v-bind:style="colorForDriver(driver)">
            <div class="fixed-table-row">  
              <b style="color: red;" v-if="driver.rejection_count > 0">REJECTED {{driver.rejection_count}}&nbsp;</b>
              <b style="color: red;" v-if="driver.going_offline">GOING OFFLINE&nbsp;</b>
              <b>{{callsignPrefixForDriver(driver)}}{{ driver.callsign }}</b>
              &nbsp;{{ driver.name }}
            </div>
          </td>
          <td>{{groupForDriver(driver)}}&nbsp;</b>
             </td>
          <td v-html="getEtaForDriver(driver)"></td>
          <td>{{ getFOJCountForDriver(driver) }}</td>
          <td>{{ getEtaToDropoffForDriver(driver) }}</td>
          <td>
            <div class="fixed-table-row">
              {{ getDestinationForDriver(driver) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </v-layout>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "candidate_driver_list",
  components: {},
  props: {
    candidateDrivers: Array,
    taxis: Array,
    bookings: Array,
    selectedDriver: Number,
  },
  model: {
    prop: "content",
    event: "input",
  },
  computed: {},
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
    };
  },
  methods: {
    callsignPrefixForDriver(driver) {
      var group = "";

      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driverGroupId == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].callsignPrefix;
        }
      }

      
      return group;
    },
    groupForDriver(driver) {
      var group = "";

     
      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driverGroupId == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].name;
        }
      }

      
      return group;
    },
    colorForDriver(driver) {
      var style = {};

      var taxi = this.taxis.find(function (t) {
        return t.id == driver.taxi_id;
      });

      if (taxi == null) {
        return null;
      }

      var ow = new Overwatch(this.taxis, this.bookings);
      return { backgroundColor: ow.colorForTaxi(taxi) };
    },
    styleForRow(driver) {
      var style = { cursor: "pointer" };

      if (driver.id == this.selectedDriver) {
        style["background-color"] = "#dedede !important";
      }

      return style;
    },
    selectDriver(id) {
      console.log("Selected " + id);
      this.$emit("input", id);
    },
    getFOJCountForDriver(driver) {
      var ow = new Overwatch(this.taxis, this.bookings);

      var taxi = this.taxis.find(function (t) {
        return t.id == driver.taxi_id;
      });

      if (
        taxi == null ||
        taxi.follow_on_job_count == null ||
        taxi.follow_on_job_count == 0
      ) {
        return "-";
      }

      return taxi.follow_on_job_count;
    },
    getLastBookingForDriver(driver) {
      var ow = new Overwatch(this.taxis, this.bookings);

      var taxi = this.taxis.find(function (t) {
        return t.id == driver.taxi_id;
      });

      if (taxi == null) {
        return null;
      }

      if (taxi.state == "available") {
        return null;
      }

      if (taxi.follow_on_job_count == 0) {
        var job = ow.getJobForTaxi(driver.taxi_id);

        return job;
      }

      var fojs = ow.getAcceptedFollowOnBookingsForTaxi(taxi);

      if (fojs.length == 0) {
        return "error";
      }

      var foj = fojs[fojs.length - 1];

      return foj;
    },
    getDestinationForDriver(driver) {
      var ow = new Overwatch(this.taxis, this.bookings);

      var booking = this.getLastBookingForDriver(driver);

      if (booking == null) {
        return "-";
      }

      if (booking.destinations == null || booking.destinations.length == 0) {
        return "Unknown";
      }

      return Overwatch.prettifyAddress(booking.destinations[0].description);
    },
    getEtaToDropoffForDriver(driver) {
      var ow = new Overwatch(this.taxis, this.bookings);

      var booking = this.getLastBookingForDriver(driver);

      if (booking == null) {
        return "-";
      }

      var taxi = this.taxis.find(function (t) {
        return t.id == driver.taxi_id;
      });

      if (taxi.follow_on_job_count == 0) {
        return this.minutesToHoursMinutesString(
          this.etaForBooking(driver, booking)
        );
      } else {
        return this.minutesToHoursMinutesString(
          this.etaForFollowOnBooking(booking)
        );0
      }
    },
    getEtaForDriver(driver) {
      return (
        this.minutesToHoursMinutesString(driver.minutes_to_pickup) +
        "/<b>" +
        this.eta(driver.minutes_to_pickup) +
        "</b>"
      );
    },
    eta: function (etaMinutes) {
      return moment(new Date()).add(etaMinutes, "minutes").format("HH:mm");
    },
    durationToHoursMinutesString: function (duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    minutesToHoursMinutesString: function (minutes) {
      var duration = moment.duration(minutes, "minutes");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    },
    etaForBooking: function (driver, booking) {
      var ow = new Overwatch(this.taxis, this.bookings);

      if (booking.taxis != null) {
        for (var i = 0; i < booking.taxis.length; i++) {
          var taxi = booking.taxis[i];
          if (taxi.id == driver.taxi_id && taxi.eta != null) {
            return taxi.eta;
          }
        }
      }

      return "";
    },
    etaForFollowOnBooking: function (booking) {

      if (booking.follow_on_taxis == null) {
        return "";
      }

      for (var i = 0; i < booking.follow_on_taxis.length; i++) {
        var taxi = booking.follow_on_taxis[i];
        if (taxi.eta != null) {
          // if driver hasnt arrived, we need to add in the time it takes for him to driver the trip
          if (booking.arrived_time == null && booking.route != null) {
            return taxi.eta + booking.route.time / 60;
          } else {
            return taxi.eta;
          }
        }
      }
      return "";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#overflow-container {
  overflow-y: scroll;
}

tr {
  background-color: white !important;
}

.candidate-table {
  font-size: 12px;
}
</style>
